module.exports = __webpack_public_path__ + "static/media/TRIAL-1-if-wrong-after-10-sec.3f02ee1f.mp3";